import Tooltip from './Tooltip'

export default function FormFieldFile (props) {
  return (
    <div className="wp-block-gds-lead-form__form-field">
      <div className="ginput_container ginput_container_fileupload">
        {props.label && (
          <label>
            {props.label}{props.required ? '*' : ''}
            {props.tooltip && <Tooltip>{props.tooltip}</Tooltip>}
          </label>
        )}
        <input
          type="file"
          required={props.required}
          accept={props.accept}
          onChange={e => {
            if (e.target.files?.length > 0) {
              props.onChange?.(e.target.files[0])
            } else {
              props.onChange?.(null)
            }
          }}
        />
      </div>
    </div>
  )
}
